import ExpandMoreRounded from '@mui/icons-material/ExpandMoreRounded';
import {
  MenuItem, Select, Typography,
} from '@mui/material';
import styled from 'styled-components';

interface DesktopSelectorProps {
  $orientation: 'vertical' | 'horizontal',
  $justifyContent: 'flex-start' | 'center' | 'flex-end',
  $dense: boolean,
}

const DesktopSelector = styled.div<DesktopSelectorProps>`
  display: flex;
  flex-direction: ${({ $orientation }) => ($orientation === 'vertical' ? 'column' : 'row')};
  align-items: center;
  justify-content: ${({ $justifyContent }) => $justifyContent};
  gap: ${({ theme, $orientation }) => ($orientation === 'vertical' ? theme.spacing(1) : 0)};
  margin-bottom: ${({ theme, $orientation, $dense }) => ($orientation === 'vertical' || $dense ? 0 : theme.spacing(4))};
`;

const Tab = styled.div`
  margin-left: ${({ theme }) => theme.spacing(2)};
  margin-right: ${({ theme }) => theme.spacing(2)};
`;

interface TabTextProps {
  $selected: boolean,
  $color: 'primary' | 'error' | 'success'
}

const TabText = styled(Typography)<TabTextProps>`
  && {
    &:hover {
      background-color: ${({ theme }) => theme.palette.backdrop.main};
      color: ${({ theme, $color }) => theme.palette[$color].dark};
    }
    border-radius: ${({ theme }) => theme.shape.borderRadius * 3}px;
    padding: ${({ theme }) => theme.spacing(0.5, 1.5)};
    color: ${({ $selected, theme, $color }) => ($selected ? theme.palette[$color].dark : theme.palette.gray.main)};
    font-weight: ${({ $selected }) => ($selected ? 600 : 'none')};
    border-color: ${({ theme, $color }) => theme.palette[$color].dark};
    background-color: ${({ theme, $selected }) => ($selected ? theme.palette.backdrop.main : 'inherit')};
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: ${({ theme }) => theme.spacing(1)};
    align-items: center;
  }
`;

interface MobileSelectorProps {
  $justifyContent: 'flex-start' | 'center' | 'flex-end',
  $dense: boolean,
}

const MobileSelector = styled.div<MobileSelectorProps>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: ${({ $justifyContent }) => $justifyContent};
  padding-left: ${({ theme, $dense }) => ($dense ? 0 : theme.spacing(2))};
  padding-right: ${({ theme, $dense }) => ($dense ? 0 : theme.spacing(2))};
  margin-bottom: ${({ theme, $dense }) => ($dense ? 0 : theme.spacing(4))};
`;

const Dropdown = styled(Select)`
  && {
    width: 240px;
    height: 40px;
    background-color: 'none';
    border: ${({ theme }) => `1.5px solid ${theme.palette.backdrop.main}`};
    border-radius: ${({ theme }) => theme.shape.borderRadius}px;
    text-align: center;
    font-weight: 600;
    color: ${({ theme }) => theme.palette.gray.main};
    & .MuiOutlinedInput-notchedOutline {
      border: none;
    };
    & .MuiSelect-select {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: ${({ theme }) => theme.spacing(1)};
    }
  }
`;

const DropdownIcon = styled(ExpandMoreRounded)`
  && {
    color: ${({ theme }) => theme.palette.gray.main};
  }
`;

const DropdownItem = styled(MenuItem)`
  && {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: ${({ theme }) => theme.spacing(1)};
    color: ${({ theme }) => theme.palette.gray.dark};
  }
`;

export { DesktopSelector,
  Tab,
  MobileSelector,
  Dropdown,
  TabText,
  DropdownIcon,
  DropdownItem };
